import React, { useEffect, useRef, useState } from 'react';
import './StatStrip.css';

/**
 * items = [{ value: 300, unit: 'k+', label: 'People Reached' }, …]
 * duration = milliseconds for the count-up animation
 */
export default function StatStrip({ items, duration = 1200 }) {
  const [start, setStart] = useState(false);
  const stripRef           = useRef(null);

  // Fire once when the strip scrolls ~30 % into view
  useEffect(() => {
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStart(true);
          io.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (stripRef.current) io.observe(stripRef.current);
    return () => io.disconnect();
  }, []);

  return (
    <div className="statstrip" ref={stripRef}>
      {items.map((item, i) => (
        <AnimatedNumber
          key={i}
          value={item.value}
          unit={item.unit}
          label={item.label}
          start={start}
          duration={duration}
        />
      ))}
    </div>
  );
}

/* ────────────────────────────────────────────────────────────── */

function AnimatedNumber({ value, unit = '', label, start, duration }) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!start) return;

    let startTime = null;
    const step = ts => {
      if (!startTime) startTime = ts;
      const progress = Math.min((ts - startTime) / duration, 1);
      setDisplay(Math.floor(progress * value));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [start, value, duration]);

  return (
    <div className="statstrip__stat">
      <span className="statstrip__value">
        {display}
        {unit}
      </span>
      <span className="statstrip__label">{label}</span>
    </div>
  );
}
